import { useRoutes } from 'react-router-dom';
import { useState, useEffect } from 'react';
import router from 'src/router';
import { Box, CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import PlayersPage from './content/pages/PlayersPage';
import Footer from './components/Footer';
import Logo from './components/LogoSign';
import LoginDialog from './components/LoginDialog';
import HeaderUserbox from './layouts/SidebarLayout/Header/Userbox';

function App() {
  const content = useRoutes(router);
  const onlyRTC = process.env.REACT_APP_ONLY_RTC === 'true'; // Convert string value to Boolean
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [openLoginDialog, setOpenLoginDialog] = useState(false);

  // Check if user is authenticated
  const checkAuth = () => {
    // Check if user is authenticated
    const authStatus = sessionStorage.getItem('isAuthenticated');
    // If user is not authenticated, show login dialog
    if (!authStatus) {
      setOpenLoginDialog(true);
    } else {
      // Check if user type is correct
      const storedUserType = sessionStorage.getItem('userType');
      const correctUserType = onlyRTC ? 'ftc' : 'dashboard';

      // If user type is correct, set isAuthenticated to true
      if (storedUserType === correctUserType) {
        setIsAuthenticated(true);
      } else {
        // If user type is incorrect, remove isAuthenticated and userType from sessionStorage and show login dialog
        sessionStorage.removeItem('isAuthenticated');
        sessionStorage.removeItem('userType');
        setOpenLoginDialog(true);
      }
    }
  };

  // Handle login submit
  const handleLoginSubmit = (username: string, password: string): boolean => {
    // Check if username and password are correct according to the onlyRTC
    const isValid = onlyRTC
      ? username === process.env.REACT_APP_FTC_USER && password === process.env.REACT_APP_FTC_PASSWORD
      : username === process.env.REACT_APP_DASHBOARD_USER && password === process.env.REACT_APP_DASHBOARD_PASSWORD;

    if (isValid) {
      // If credentials are correct, set isAuthenticated to true
      setIsAuthenticated(true);
      // Set isAuthenticated and userType in sessionStorage
      sessionStorage.setItem('isAuthenticated', 'true');
      sessionStorage.setItem('userType', onlyRTC ? 'ftc' : 'dashboard');
      // Close login dialog
      setOpenLoginDialog(false);
    }

    return isValid;
  };

  // Check if user is authenticated when onlyRTC changes
  useEffect(() => {
    checkAuth();
  }, [onlyRTC]); // Add onlyRTC as a dependency

  return (
    <ThemeProvider>
      <CssBaseline />
      <LoginDialog
        open={openLoginDialog}
        onClose={() => setOpenLoginDialog(true)} // Not allow to close without valid credentials
        onSubmit={handleLoginSubmit}
      />
      {onlyRTC ? (
        //Render only PlayerPage if onlyRtc is true
        <Box sx={{ mt: 3 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', ml: 3, mr: 3, textAlign: 'left' }}>
             <Box sx={{ width: '100px' }}>
              <Logo />
            </Box>
            <HeaderUserbox />
          </Box>
        

          <Box sx={{ mt: 2 }}>
            <PlayersPage />
            <Footer />
          </Box>
        </Box>
      ) : (
        //Render the entire app if onlyRtc is false
        <>{content}</>
      )}
    </ThemeProvider>
  );
}

export default App;
